const dateInputValue = (value) => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const paymentToday = () => dateInputValue(new Date());

export const blankPaymentForm = () => ({
  interest_amount: "",
  penalty_amount: "",
  main_debt: "",
  referral_commission: "",
  note: "",
  payment_date: paymentToday(),
  settle_remark: "",
  settled_date: "",
});

export const paymentFormFromPayment = (payment) => ({
  interest_amount: payment?.interest_amount ?? "0",
  penalty_amount: payment?.penalty_amount ?? "0",
  main_debt: payment?.main_debt ?? payment?.amount ?? "0",
  referral_commission: payment?.referral_commission ?? "0",
  note: payment?.note ?? "",
  payment_date: payment?.payment_date ?? "",
  settle_remark: "",
  settled_date: "",
});

export const generatedPaymentForm = (form) => {
  const values = {
    ...form,
    interest_amount: form.interest_amount || "0",
    penalty_amount: form.penalty_amount || "0",
    main_debt: form.main_debt || "0",
    referral_commission: form.referral_commission || "0",
  };

  return {
    ...values,
    note: [
      `INTEREST RM${values.interest_amount}`,
      `PENALTY RM${values.penalty_amount}`,
      `MAIN DEBT RM${values.main_debt}`,
      `REFERRAL COMISSION RM${values.referral_commission}`,
    ].join("\n"),
  };
};

export const paymentPayload = (form) => ({
  interest_amount: Number(form.interest_amount),
  penalty_amount: Number(form.penalty_amount),
  main_debt: Number(form.main_debt),
  referral_commission: Number(form.referral_commission),
  note: form.note,
  payment_date: form.payment_date || null,
});

export const hasPaymentAmount = (form) => {
  return [
    form.interest_amount,
    form.penalty_amount,
    form.main_debt,
    form.referral_commission,
  ].some((value) => Number(value) > 0);
};

export const settlementTotal = (form) => {
  return (
    Number(form.main_debt || 0)
    + Number(form.interest_amount || 0)
    + Number(form.penalty_amount || 0)
    + Number(form.referral_commission || 0)
  );
};